import { useContext } from 'react';

import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

import HasSchoolDistrictInput from './HasSchoolDistrictInput';
import HighestGradeInput from './HighestGradeInput';
import LowestGradeInput from './LowestGradeInput';
import SchoolDistrictNameInput from './SchoolDistrictNameInput';
import ExistingPartnerSelect from '../common/ExistingPartnerSelect';
import NewPartnerSection from '../common/IntakeNewPartnerSection';
import NewPartnerSectionHeader from '../common/IntakeNewPartnerSectionHeader';
import IntakePrimaryContact from '../common/IntakePrimaryContact';
import RowWrap from '../common/IntakeRowWrap';
import IntakeShippingContact from '../common/IntakeShippingContact';
import IntakeSubmitButton from '../common/IntakeSubmitButton';
import NewPartnerCheckbox from '../common/NewPartnerCheckbox';
import PartnerCategoryInput from '../common/PartnerCategoryInput';
import PartnerNameInput from '../common/PartnerNameInput';
import { IntakeResponse } from '@/models/IntakeResponse';
import { ProgramProps } from '@/models/Program';
import { PartnerProps } from '@/models/Partner';

interface TreeCampusK12SignUpProps {
  onSubmit: (intakeResponse: IntakeResponse) => void;
  selectedProgramInfo: ProgramProps;
  partnerInfo: PartnerProps;
}

function TreeCampusK12SignUp({
  onSubmit,
  selectedProgramInfo,
  partnerInfo,
}: TreeCampusK12SignUpProps) {
  const { isNewPartner, disabledNewPartnerCheckbox } = useContext(PartnerIntakeContext);

  return (
    <>
      <IntakePrimaryContact />

      {!isNewPartner && <ExistingPartnerSelect />}

      {!disabledNewPartnerCheckbox && <NewPartnerCheckbox />}

      {isNewPartner && (
        <NewPartnerSection>
          <NewPartnerSectionHeader />

          <RowWrap>
            <HasSchoolDistrictInput />
            {partnerInfo.schoolDistrict ? <SchoolDistrictNameInput /> : <></>}
          </RowWrap>

          {selectedProgramInfo.displayCategory && <PartnerCategoryInput />}

          <PartnerNameInput />

          {selectedProgramInfo.displayLowestGrade && (
            <RowWrap>
              <LowestGradeInput />
              <HighestGradeInput />
            </RowWrap>
          )}

          <IntakeShippingContact />
        </NewPartnerSection>
      )}
      <IntakeSubmitButton onSubmit={onSubmit} />
    </>
  );
}

export default TreeCampusK12SignUp;
